import React, {Component} from 'react'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'
import {actionCreators} from 'actions'
import api from 'api'
import {connect} from 'react-redux'

class ChooseProcedureTypeForMember extends Component {
  componentDidMount() {
    const {loadProcedures, token} = this.props
    loadProcedures(token)
  }

  render() {
    const {procedureStatuses} = this.props
    return (
      <div>
        <div className="l-title-wrap">
          <h1 className="m-title-main">産休の手続きを選択</h1>
        </div>
        <Container>
          <StartProcedureCard to="/start_maternity/employee_input" variant="start">
            産休の開始
            <br />
            （出産予定日の連絡）
          </StartProcedureCard>
          {procedureStatuses.length > 0 && (
            <StartProcedureCard to="/change_maternity/choose_procedure" variant="start">
              産休の届出情報の変更
              <br />
              （出産日の報告）
            </StartProcedureCard>
          )}
        </Container>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    procedureStatuses: state.procedureStatuses.list.data || [],
    token: state.auth.token,
  }),
  (dispatch) => ({
    loadProcedures(token) {
      api
        .createWithAuth(token)
        .employees.getCurrent(['office'])
        .then((res) => {
          if (res?.data) {
            dispatch(
              actionCreators.procedureStatuses.list.fetchData(
                api
                  .createWithAuth(token)
                  .procedureStatuses.list({procedure_type: 'start_maternity', employee_id: res.data.id}, [
                    'employee',
                    'procedure_maternity_datum',
                  ])
              )
            )
          }
        })
    },
  })
)(ChooseProcedureTypeForMember)
